export const STATUS_UNCOMPLETED = 0
export const STATUS_APPROVAL_PENDING = 1
export const STATUS_APPROVED = 2
export const STATUS_APPROVAL_REJECTED = 3
export const STATUS_IRRELEVANT = 4
export const STATUS_CHECKED_OFF = 5
export const STATUS_REAPPROVAL_REQUESTED = 6

export default {
    STATUS_UNCOMPLETED,
    STATUS_APPROVAL_PENDING,
    STATUS_APPROVED,
    STATUS_APPROVAL_REJECTED,
    STATUS_IRRELEVANT,
    STATUS_CHECKED_OFF,
    STATUS_REAPPROVAL_REQUESTED,
}
